export type SingleAccountManager = {
	title: string;
	firstName: string;
	middleNames: string;
	lastName: string;
	fullName: string;
	emailAddress: string;
	workTelephone: string;
	mobileTelephone: string;
	jobTitle: string;
	positionName: string;
};

const model: types.models.InputModel = {
	title: 'title',
	firstName: 'firstName',
	middleNames: 'middleNames',
	lastName: 'lastName',
	fullName: 'fullName',
	emailAddress: 'emailAddress',
	workTelephone: 'workTelephone',
	mobileTelephone: 'mobileTelephone',
	jobTitle: 'jobTitle',
	positionName: 'positionName',
};

export default model;
